// ModalComponents.js (Reusable components)

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


// Confirm Modal Component
export const ConfirmModal = ({ onClose, onConfirm }) => (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Confirm your selection</h2>
      <p>Are you sure these are the products you want every month?</p>
      <div className="mt-4 flex justify-end">
        <button onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded mr-2">Cancel</button>
        <button onClick={onConfirm} className="bg-green-500 text-white px-4 py-2 rounded">Confirm</button>
      </div>
    </div>
  </div>
);



export const DeliveryDateModal = ({ onClose }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleConfirm = () => {
    if (!selectedDate) {
      setError('Please select a delivery date');
    } else {
      setError('');
      // Navigate to CheckoutPage
      navigate('/CheckoutPage');
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-lg">
        <h2 className="text-xl font-semibold mb-4">Select Delivery Date</h2>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="border border-gray-300 p-2 rounded w-full mb-2"
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <div className="flex justify-end mt-4">
          <button onClick={handleConfirm} className="bg-green-500 text-white px-4 py-2 rounded">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
